import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=8a81bdf8&scoped=true"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"
import style0 from "./Reader.vue?vue&type=style&index=0&id=8a81bdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a81bdf8",
  null
  
)

export default component.exports